import { UploadOutlined } from '@ant-design/icons'
import { Button, Upload } from 'antd'
import { parse } from 'papaparse'
import { z } from 'zod'
import i18n from '~app/i18n/i18n'

/**
 * Utils
 */

export type CSVColumn = {
  returnId: string
  trackingId: string
}

const columnSchema = z.object({
  returnId: z.string().min(1),
  trackingId: z.string().min(1),
})

/**
 * Component
 */

type CSVImporterProps = {
  onImport: (columns: CSVColumn[]) => unknown
}

const CSVImporter = ({ onImport }: CSVImporterProps) => {
  const handleUpload = (file: File) => {
    parseFile(file)
    return false
  }

  const parseFile = (fileContent: File) => {
    parse(fileContent, {
      header: true,
      delimiter: ';',
      complete: async parseResults => {
        const rows = parseResults.data as any[]
        const columns = rows
          .map<CSVColumn>(row => ({
            returnId: row['CAYA Return ID'],
            trackingId: row['DHL Tracking ID'],
          }))
          .filter(column => columnSchema.safeParse(column).success)
        await onImport(columns)
      },
    })
  }

  return (
    <Upload
      beforeUpload={handleUpload}
      accept="text/csv"
      showUploadList={false}
    >
      <Button type="primary" icon={<UploadOutlined />}>
        {i18n.t('returns.uploadTrackingCsvBtnLabel')}
      </Button>
    </Upload>
  )
}

export default CSVImporter
